<div *transloco="let t" class="h-full w-full">
	<mat-card class="h-full w-full">
		<!--        <mat-card-header>-->
		<!--            <mat-card-title> {{ t('documentTransfer.fileList') }}</mat-card-title>-->
		<!--        </mat-card-header>-->
		<mat-card-content>
			<div class="card overflow-auto">
				<div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex flex-row justify-start items-center">
					<h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden xs:block">
						<span>{{ t('documentTransfer.fileList') }}</span>
					</h2>
					<div class="bg-card rounded-full border px-4 bg-white flex flex-row w-[400px] md:w-auto justify-start items-center">
						<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
						<input
							#input
							[delayedSearch]="searchFilterSubject"
							class="px-4 py-3 border-0 outline-none w-full bg-transparent"
							matInput
							name="searchField"
							placeholder="{{ t('commonActions.search') }}"
							type="search" />
					</div>
					<button (click)="clearAllFilters()" mat-icon-button matTooltip="{{ t('commonActions.clearAllFiltersTooltip') }}">
						<mat-icon [svgIcon]="icons.get('filterOff')"></mat-icon>
					</button>
				</div>
				@if (isLoading()) {
					<div @fadeInUp class="flex flex-row justify-center">
						<mat-spinner color="primary"></mat-spinner>
					</div>
				} @else {
					<table mat-table [dataSource]="dataSource" matSort matSortActive="reNumber" matSortDirection="asc" class="w-full">
						<ng-container matColumnDef="select">
							<th mat-header-cell *matHeaderCellDef>
								<mat-checkbox
									(change)="$event ? masterToggle() : null"
									[checked]="selection.hasValue() && isAllSelected()"
									[indeterminate]="selection.hasValue() && !isAllSelected()"
									[aria-label]="checkboxLabel()"></mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox
									(click)="$event.stopPropagation()"
									(change)="$event ? selection.toggle(row) : null"
									[checked]="selection.isSelected(row)"
									[aria-label]="checkboxLabel(row)"></mat-checkbox>
							</td>
						</ng-container>

						<ng-container matColumnDef="selectFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>
						<ng-container matColumnDef="reNumberFilter">
							<th *matHeaderCellDef mat-header-cell>
								<ara-search-select
									(newFilters)="reloadDataWithFilter('reNumber', $event)"
									[clearFilter]="clearFilter"
									[data]="filterData('reNumber')"
									[label]="t('documentTransfer.reNumber')"
									[preSetCheckedData]="preSetCheckedDataReNumber"></ara-search-select>
							</th>
						</ng-container>
						<ng-container matColumnDef="tuNumberFilter">
							<th *matHeaderCellDef mat-header-cell>
								<ara-search-select
									(newFilters)="reloadDataWithFilter('tuNumber', $event)"
									[clearFilter]="clearFilter"
									[data]="filterData('tuNumber')"
									[label]="t('documentTransfer.tuNumber')"
									[preSetCheckedData]="preSetCheckedDataTuNumber"></ara-search-select>
							</th>
						</ng-container>
						<ng-container matColumnDef="propertyManagementFilter">
							<th *matHeaderCellDef mat-header-cell>
								<ara-search-select
									(newFilters)="reloadDataWithFilter('propertyManagement', $event)"
									[clearFilter]="clearFilter"
									[data]="filterData('propertyManagement')"
									[label]="t('documentTransfer.propertyManagement')"
									[preSetCheckedData]="preSetCheckedDataPropertyManagement"></ara-search-select>
							</th>
						</ng-container>
						<ng-container matColumnDef="fileNameFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>
						<ng-container matColumnDef="fileTypeFilter">
							<th *matHeaderCellDef mat-header-cell>
								<ara-search-select
									(newFilters)="reloadDataWithFilter('fileType', $event)"
									[clearFilter]="clearFilter"
									[data]="filterData('fileType')"
									[label]="t('documentTransfer.fileType')"
									[preSetCheckedData]="preSetCheckedDataFileType"></ara-search-select>
							</th>
						</ng-container>
						<ng-container matColumnDef="fileSizeFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>
						<ng-container matColumnDef="uploadDateFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>
						<ng-container matColumnDef="lastDownloadDateFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>
						<ng-container matColumnDef="deletionDateFilter">
							<th *matHeaderCellDef mat-header-cell></th>
						</ng-container>

						<ng-container matColumnDef="reNumber">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.reNumber') }}</th>
							<td mat-cell *matCellDef="let row">{{ row.reNumber }}</td>
						</ng-container>

						<ng-container matColumnDef="tuNumber">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.tuNumber') }}</th>
							<td mat-cell *matCellDef="let row">{{ row.tuNumber }}</td>
						</ng-container>

						<ng-container matColumnDef="propertyManagement">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.propertyManagement') }}</th>
							<td mat-cell *matCellDef="let row">
								<div class="text-content">
									<span [matTooltip]="getPropertyManagementName(row.propertyManagement)" class="truncate-text-content">
										{{ getPropertyManagementName(row.propertyManagement) }}
									</span>
								</div>
							</td>
						</ng-container>

						<!-- Filename Column -->
						<ng-container matColumnDef="fileName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.fileName') }}</th>
							<td mat-cell *matCellDef="let row">
								<div class="text-content">
									<span [matTooltip]="row.fileName" class="truncate-text-content">
										{{ row.fileName }}
									</span>
								</div>
							</td>
						</ng-container>

						<!-- FileType Column -->
						<ng-container matColumnDef="fileType">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.fileType') }}</th>
							<td mat-cell *matCellDef="let row">{{ t('enum.' + row.fileType).replace('enum.', '') }}</td>
						</ng-container>

						<ng-container matColumnDef="fileSize">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.fileSize') }}</th>
							<td mat-cell *matCellDef="let row">{{ getByteFileSizeString(row?.fileSize) }}</td>
						</ng-container>

						<!-- Upload Date Column -->
						<ng-container matColumnDef="uploadDate">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.uploadDate') }}</th>
							<td mat-cell *matCellDef="let row">{{ row.uploadDate }}</td>
						</ng-container>

						<!-- Deletion Date Column -->
						<ng-container matColumnDef="deletionDate">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('documentTransfer.deletionDate') }}</th>
							<td mat-cell *matCellDef="let row">{{ row.deletionDate }}</td>
						</ng-container>

						<ng-container matColumnDef="actions">
							<th mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let row">
								<button mat-icon-button [matMenuTriggerFor]="rowActionMenu">
									<mat-icon>more_vert</mat-icon>
								</button>
								<mat-menu #rowActionMenu="matMenu">
									<button mat-menu-item (click)="onDownloadClick(row)">
										<mat-icon>download</mat-icon>
										<span>{{ t('uploadDirective.downloadFile') }}</span>
									</button>
									<span
										matTooltip="{{ t('documentTransfer.previewNotPossibleDueToFileType') }}"
										matTooltipPosition="below"
										[matTooltipDisabled]="row?.fileType !== ContentTypeEnum.UNDEFINED">
										<button mat-menu-item (click)="onPreviewClick(row)" [disabled]="row?.fileType === ContentTypeEnum.UNDEFINED">
											<mat-icon>preview</mat-icon>
											<span>{{ t('outbox.preview') }}</span>
										</button>
									</span>
									<button mat-menu-item (click)="onDeleteClick(row)">
										<mat-icon>delete</mat-icon>
										<span>{{ t('commonActions.delete') }}</span>
									</button>
								</mat-menu>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr *matHeaderRowDef="displayedColumnFilters" mat-header-row style="margin-top: -15px !important"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

						<tr class="mat-row" *matNoDataRow>
							<td class="mat-cell" [attr.colspan]="displayedColumns.length">
								{{ t('dashboard.noDataFound') }}
							</td>
						</tr>
					</table>
				}

				<ara-paginator
					[pageSize]="pageSize"
					[pageIndex]="pageIndex"
					[pageSizeOptions]="pageSizeOptions"
					attr.aria-label="{{ t('common.choosePage') }}"></ara-paginator>
			</div>
		</mat-card-content>

		<mat-card-actions>
			<button (click)="multiDownload()" mat-raised-button color="primary" class="m-2" [disabled]="!multiDownloadEnabled">
				<mat-icon [svgIcon]="icons.get('fileDownload')"></mat-icon>
				<span class="pl-2">
					{{ t('documentTransfer.multiDownload') }}
					{{ selection.selected?.length ? '(' + selection.selected.length + '; ' + getByteFileSizeString(totalSelectedSize) + ')' : '' }}
				</span>
			</button>
			<span class="pl-2" [hidden]="!multiDownloadMaxFileSizeExceeded">
				{{ t('documentTransfer.multiDownloadMaxFileSizeExceeded', { maxFileSize: this.getByteFileSizeString(MAX_DOWNLOAD_SIZE_BYTES) }) }}
			</span>
		</mat-card-actions>
	</mat-card>
</div>
